import Swiper, { Autoplay, Navigation } from 'swiper';
import 'swiper/css';
// import 'swiper/css/autoplay';
// import 'swiper/css/effect-fade';
// import 'swiper/css/navigation';

export default class {
  constructor(el) {
    this.dom = {el: el};
    this.dom.slider = this.dom.el.querySelector('.swiper');

    this.slider = null;
    this.option = {
      modules: [Autoplay, Navigation],
      init: false,
      loop: true,
      speed: 1200,
      centeredSlides: true,
      slidesPerView: (375 / (192.5 + 65.5)),
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      },
      noSwiping: false,
      navigation: {
        nextEl: this.dom.el.querySelector('.swiper-button-next'),
        prevEl: this.dom.el.querySelector('.swiper-button-prev'),
      },
      breakpoints: {
        768: {
          centeredSlides: false,
          slidesPerView: (1252 / 569)
        }
      }
      // pagination: {
      //   el: this.dom.el.querySelector('.swiper-pagination'),
      //   type: 'bullets',
      //   renderBullet: (index, className) => {
      //     //中に数字を表示
      //     return '<span class="' + className + '"><svg width="30" height="30"><circle cx="15" cy="15" r="14.5" data-js="swpr-bullet" /></svg>' + '0' + (index + 1) + '</span>';
      //   }
      // },
    };

    this.init();
  }

  init() {
    const _this = this;
    this.slider = new Swiper(this.dom.slider, this.option);
    this.slider.init();
    // this.autoplay();

    // this.slider.on('slideChangeTransitionStart', e => {
    //   console.log('start');
    //   const slides = _this.dom.el.querySelectorAll('.swiper-slide');
    //   console.log(slides);
    //   [...slides].forEach(el => {
    //     el.dataset.action = 'none';
    //   });
    //   console.log(_this.slider.realIndex);
    //   const active = _this.dom.el.querySelector('.swiper-slide-active');
    //   active.dataset.action = 'scale';
    // });
  }

  // autoplay() {
  //   const _this = this;
  //   this.dom.bullet = this.dom.el.querySelectorAll('[data-js="swpr-bullet"]');

  //   [...this.dom.bullet].forEach((elm, i)=>{
  //     const index = Number(i) * 1 + 1;
  //     elm.addEventListener('animationend', ()=>{
  //       _this.slider.slideTo(index + 1);
  //     });
  //   });
  // }

  destroy() {
    this.slider.destroy(true, true);
  }
}
